// extracted by mini-css-extract-plugin
export var container = "HomeSearchBar-module__container___tJ8zJ";